/**
 * @generated SignedSource<<6ceac0779933081d03fff2d734fe5caa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateSubscriptionPlanDevInput = {
  planId: string;
};
export type SubscriptionPlanUpdateDevMutation$variables = {
  input: UpdateSubscriptionPlanDevInput;
};
export type SubscriptionPlanUpdateDevMutation$data = {
  readonly updateSubscriptionPlanDev: {
    readonly id: string;
  };
};
export type SubscriptionPlanUpdateDevMutation = {
  response: SubscriptionPlanUpdateDevMutation$data;
  variables: SubscriptionPlanUpdateDevMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSubscriptionPlanDevResult",
    "kind": "LinkedField",
    "name": "updateSubscriptionPlanDev",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionPlanUpdateDevMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionPlanUpdateDevMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eaf9c75085e25d78cca4edb27322dee0",
    "id": null,
    "metadata": {},
    "name": "SubscriptionPlanUpdateDevMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionPlanUpdateDevMutation(\n  $input: UpdateSubscriptionPlanDevInput!\n) {\n  updateSubscriptionPlanDev(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "233b18966c5b2f9305595009c351ff89";

export default node;
